<template>
  <HPopup class="h-confirm"
          ref="popup"
          :visible.sync="visible"
          :z-index="zIndex"
          :close-on-click-modal="false">
    <div class="popup-body">
      <slot>
        <p class="h-confirm-default-content">{{ message }}</p>
      </slot>
      <div class="textarea-field h-outer-border around-4 bw2 bz0 h-bg brown-2" v-if="config.textarea">
        <textarea class="scrollbar scroll-v" v-model="textarea" ref="textarea" rows="5"
                  :maxlength="config.maxLength || 255"
                  spellcheck="false"
                  :placeholder="config.placeholder"
                  @focus="textareaErrorMsg=''"></textarea>
      </div>
      <div v-else-if="config.input" class="textarea-field h-outer-border around-4 bw2 bz0 h-bg brown-2">
        <input v-model="textarea"
               ref="textarea"
               :maxlength="config.maxLength || 64"
               spellcheck="false"
               :placeholder="config.placeholder"
               @focus="textareaErrorMsg=''">
      </div>
      <p class="error-message" v-show="(config.textarea || config.input) && textareaErrorMsg">{{ textareaErrorMsg }}</p>
      <footer class="footer">
        <button v-click-sound-button
                class="h-button ok"
                @click="handleSubmit">
        </button>
        <button v-click-sound-button
                class="h-button close"
                @click="handleCancel">
        </button>
      </footer>
    </div>
  </HPopup>
</template>

<script>
  import Bus from '@/assets/js/global-bus'
  import HPopup from '@/components/h-popup/index.vue'

  export default {
    name: 'HConfirm',

    beforeDestroy () {
      Bus.off('keyup', this.keyUpHandler)
    },

    data () {
      return {
        callback: null,
        textarea: '',
        textareaErrorMsg: ''
      }
    },

    props: {
      visible: {
        type: Boolean,
        default: false
      },
      zIndex: {
        type: Number,
        default: 2000
      },
      message: {
        type: String,
        default: ''
      },
      config: {
        type: Object,
        default () {
          return {}
        }
      },
    },

    watch: {
      visible (val) {
        if (val && (this.config.textarea || this.config.input)) {
          this.$nextTick(() => {
            this.$refs.textarea.focus()
            if (this.config.value) {

              this.textarea = this.config.value
            }
          })
        }
        if (!val) {
          this.textarea = ''
        }
      }
    },

    mounted () {
      Bus.on('keyup', this.keyUpHandler)
    },

    methods: {
      keyUpHandler (e) {
        if (this.visible && e.key === 'Enter' && !this.config.textarea) {
          this.$refs.button && this.$refs.button.click()
        }
      },
      handleCancel () {
        this.visible = false
        if (this.callback) {
          this.callback(false)
        }
        this.textareaErrorMsg = ''
      },
      handleSubmit () {
        if (this.config.validator) {
          const res = this.config.validator(this.textarea)
          if (res instanceof Error) {
            this.textareaErrorMsg = res.message
            return
          }
          this.textareaErrorMsg = ''
        }
        this.visible = false
        if (this.callback) {
          this.callback(this.textarea || true)
        }
      },
    },

    components: {
      HPopup
    }
  }
</script>

<style lang="stylus" scoped>
  .h-confirm
    .popup-body
      width 300px
      .h-confirm-default-content
        padding 20px 0
        line-height 20px
        font-size 14px
        text-align center
        letter-spacing 1px
        whiteText1()
      .footer
        margin-top 30px
        text-align center
        button
          outline 2px solid #e8d478
          & + button
            margin-left 20px

  .textarea-field
    position relative
    textarea
      position relative
      box-sizing border-box
      width 100%
      padding 10px
      border none
      line-height 18px
      font-size 14px
      letter-spacing 1px
      background-color transparent
      resize none
      vertical-align top
      caret-color #f8e490
      goldText1()
      &:focus
        outline none
      &::-webkit-input-placeholder
        font-size 12px
        color #999
      &::-webkit-scrollbar-track
        cursor pointer
    input
      position relative
      box-sizing border-box
      width 100%
      padding 10px
      border none
      line-height 18px
      font-size 14px
      letter-spacing 1px
      background-color transparent
      vertical-align top
      caret-color #f8e490
      goldText1()
      &:focus
        outline none
      &::-webkit-input-placeholder
        font-size 12px
        color #999
      &::-webkit-scrollbar-track
        cursor pointer

  .error-message
    padding 5px 10px
    font-size 12px
    color $colorRed1
    text-shadow 1px 1px 1px #000

</style>
